// extracted by mini-css-extract-plugin
module.exports = {"modal":"SendPackageModal_modal__2FInj"};